import lang from '@/lang'
import WebStorageKey from '@/enums/web-storage-key.enum'
import WebStorageService from '@/modules/_services/webstorage.service'

import { UNSAFE_openModal as openModal } from '@/modules/_helpers/openModal'

const openNoRoleAssignedModal = ({ isOwner = false }) => {
  const langKey = isOwner ? 'owner' : 'user'

  openModal((close) => ({
    component: 'ConfirmModal',
    props: {
      noCancel: true,
      title: lang.noRole.modal[langKey].title,
      description: lang.noRole.modal[langKey].description,
      disableBackdropClick: false,
      onConfirm: () => {
        WebStorageService.setItem(WebStorageKey.NO_ROLE_ASSIGNED_CONFIRMED, true)
        close()
      },
    },
  }))
}

export default openNoRoleAssignedModal
